import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/wx/config/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/wx/config/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/v4ward/wx/config/remove', params,options);

export const add = (params, options) =>
request.post('/api/v4ward/wx/config/save', params,options)

export const update = (params, options) =>
request.post('/api/v4ward/wx/config/update', params,options)
